<button
  type="button"
  class="help-button"
  (click)="toggles[toggleName] = !toggles[toggleName]"
  [attr.aria-expanded]="toggles[toggleName]"
  [attr.aria-label]="'arialabel.toggle.help' | translate"
>
  <i class="icon-help-circle"></i>
</button>
